export const LOADABLE_STATE = '__LOADABLE_STATE__'
export const LOADABLE = '@@loadable-components/loadable'
